import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconModule } from '../icon/index';

import { CameraComponent } from './camera.component';

export { CameraComponent } from './camera.component';

@NgModule({
  declarations: [
    CameraComponent
  ],
  imports: [
    CommonModule,

    IconModule
  ],
  exports: [
    CameraComponent
  ]
})
export class CameraModule {}
